module.exports = __webpack_public_path__ + "img/play-error-img-2.be176d56.png";